import axios from 'axios'

export const addCustomerToNewsletter = async ({
    language,
    email,
    name,
    surname,
    telephone,
}) => {
    try {
        await axios.post(
            `${process.env.GATSBY_STRAPI_API_URL}/api/newsletter/add-customer`,
            {
                data: {
                    email,
                    name,
                    surname,
                    telephone,
                    language,
                },
            },
            {
                headers: {
                    Authorization: `Bearer ${process.env.GATSBY_STRAPI_API_TOKEN}`,
                },
            }
        )
    } catch (error) {}
}
